import gql from 'graphql-tag';

import dokkioTagFragment from '../fragments/dokkioTagFragment';

export const mutationUpdateDokkioTag = gql`
  mutation updateDokkioTag(
    $id: DokkioID!
    $dokkioLabelID: DokkioID
    $name: String
    $logoID: DokkioID
    $description: String
    $autoApplyConfidenceThreshold: Float
    $appliesToTypes: [AppliesToType!]
    $synonyms: [String!]
    $blacklistNames: [String!]
    $dokkioTagIDs: [DokkioID!]
    $autoRulesEnabledAt: DateTime
  ) {
    updateDokkioTag(
      id: $id
      dokkioLabelID: $dokkioLabelID
      name: $name
      logoID: $logoID
      description: $description
      autoApplyConfidenceThreshold: $autoApplyConfidenceThreshold
      appliesToTypes: $appliesToTypes
      synonyms: $synonyms
      blacklistNames: $blacklistNames
      dokkioTagIDs: $dokkioTagIDs
      autoRulesEnabledAt: $autoRulesEnabledAt
    ) {
      ...dokkioTagFragment
    }
  }
  ${dokkioTagFragment}
`;
export default mutationUpdateDokkioTag;
